import DisplayItem from '@/models/DisplayItem';
import Test from '@/models/Test';
import INavigationController from '../INavigationController';
import AbstractNavigationState from './AbstractNavigationState';
import NavigationCallbackType from './NavigationCallbackType';
import NavigationContext from './NavigationContext';
import NavigationStateDisplayType from './NavigationStateDisplayType';

class ItemNavigationState extends AbstractNavigationState {
  private showReviewScreen = true;
  constructor(
    navigationController: INavigationController,
    navigationContext: NavigationContext,
    lockSectionsEnabled: boolean,
    showReviewScreen: boolean
  ) {
    super(navigationController, navigationContext, lockSectionsEnabled);
    this.showReviewScreen = showReviewScreen;
  }

  handleForwardNavigation(navigationCallback: (NavigationCallbackType) => void): void {
    const endOfSection = this.navigationController.endOfSection();
    const endOfTest = this.navigationController.endOfTest();

    if (!this.showReviewScreen) {
      if (endOfTest || endOfSection) {
        const item: DisplayItem | null = this.navigationController.getCurrentItem();
        if (!item) {
          navigationCallback(NavigationCallbackType.NEXT);
          return;
        }

        this.displayIncompleteAlert(
          endOfSection ? item.section.getIncompleteCount() : item.section.testPart.test.getIncompleteCount(),
          endOfSection ? item.section.getFlaggedCount() : item.section.testPart.test.getFlaggedCount(),
          false,
          () => {
            navigationCallback(NavigationCallbackType.NEXT);
          },
          null
        );
      } else {
        navigationCallback(NavigationCallbackType.NEXT);
      }

      return;
    }

    if (!endOfSection && !endOfTest) {
      navigationCallback(NavigationCallbackType.NEXT);
      return;
    }

    if (endOfTest && this.showReviewScreen) {
      this.navigationContext.setNavigationState(NavigationContext.TEST_END_STATE);
      navigationCallback(NavigationCallbackType.NONE);
    } else if (endOfSection && this.showReviewScreen) {
      this.navigationContext.setNavigationState(NavigationContext.SECTION_END_STATE);
      navigationCallback(NavigationCallbackType.NONE);
    } else {
      navigationCallback(NavigationCallbackType.NEXT);
    }
  }

  handleBackNavigation(navigationCallback: (NavigationCallbackType) => void): void {
    if (this.navigationController.beginningOfSection() && this.showReviewScreen) {
      this.navigationContext.setNavigationState(NavigationContext.SECTION_END_STATE);
    }
    navigationCallback(NavigationCallbackType.BACK);
  }

  handleCurrentItemNavigation(navigationCallback: (NavigationCallbackType) => void): void {
    navigationCallback(NavigationCallbackType.CURRENT);
  }

  handleReviewSubmit(navigationCallback: (NavigationCallbackType) => void): void {
    const item: DisplayItem | null = this.navigationController.getCurrentItem();

    if (!item) {
      navigationCallback(NavigationCallbackType.NEXT);
      return;
    }

    this.displayIncompleteAlert(
      this.lockSectionsEnabled ? item.section.getIncompleteCount() : item.section.testPart.test.getIncompleteCount(),
      this.lockSectionsEnabled ? item.section.getFlaggedCount() : item.section.testPart.test.getFlaggedCount(),
      !this.lockSectionsEnabled,
      () => {
        navigationCallback(NavigationCallbackType.NEXT);
      },
      () => {
        const array = this.lockSectionsEnabled
          ? this.navigationController.getItemArray()
          : this.navigationController.getAllItems();

        this.navigationController.setCurrentItem(array[array.length - 1]);
      }
    );
  }

  getLocationState(): number {
    return Test.NO_STATE;
  }

  getDisplayType(): NavigationStateDisplayType {
    return NavigationStateDisplayType.ITEM_CONTAINER;
  }
}

export default ItemNavigationState;
